import { Component, Input } from '@angular/core';
import { charTypes } from '../../constants';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { InstrumentChartCardInput, LanguagesEnum } from '../charts';
import { SlideDirections } from 'src/app/services/rest-api/rest-api';

@Component({
  selector: 'libero-instrument-chart-carousel',
  templateUrl: './instrument-chart-carousel.component.html',
  styleUrls: ['./instrument-chart-carousel.component.scss'],
  standalone: false
})
export class InstrumentChartCarouselComponent {
  @Input() public instrumentChart?: InstrumentChartCardInput;
  @Input() public userLocalization: keyof typeof LanguagesEnum = 'cs-CZ';

  public selectedChart: charTypes = charTypes.INSTRUMENTS;

  public charTypes = charTypes;
  public slideDirections = SlideDirections;

  public constructor(
    private loggerService: LoggerService,
  ) { }

  public changeChart(direction: SlideDirections | number): void {
    if(direction === SlideDirections.NEXT) {
      this.selectedChart++;
    } else if (direction === SlideDirections.PREV) {
      this.selectedChart--;
    } else if (typeof direction === 'number') {
      this.selectedChart = direction;
    } else {
      this.loggerService.error('Unknown chart direction; ' + direction);
    }
  }

  public chartAvailable(direction: SlideDirections): boolean {
    if(direction === SlideDirections.NEXT) {
      // display chart only when creating strategy/portfolio
      return this.selectedChart < 3;
    }
    if(direction === SlideDirections.PREV) {
      return this.selectedChart > 1;
    }

    return false;
  }
}
